import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Seo from "./components/Seo";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Credentials from "./components/Credentials";
import HowItWorks from "./components/HowItWorks";
import WhyChoose from "./components/WhyChoose";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import AdminInquiries from "./components/AdminInquiries";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancelled from "./components/PaymentCancelled";
import ContactPage from "./components/ContactPage";

function HomePage() {
  return (
    <>
      <Seo
        title="Certified Translation Services | MYK"
        description="Certified translation services for legal, official, academic and personal documents in Arabic, French and Spanish, professionally prepared for use in the UK."
        path="/"
      />

      <Header />
      <Hero />
      <About />
      <Services />
      <Credentials />
      <HowItWorks />
      <WhyChoose />
      <Faq />
      <Contact />
      <Footer />
      <FloatingButtons />
    </>
  );
}

function ContactRoute() {
  return (
    <>
      <Seo
        title="Contact Certified Translation Agency | MYK"
        description="Contact MYK Certified Translations for certified, legal and official document translation quotes in Arabic, French, Spanish and English for UK use today."
        path="/contact"
      />

      <ContactPage />
    </>
  );
}

function AdminPage() {
  return (
    <>
      <Seo
        title="Admin Portal | MYK Certified Translations"
        description="Private administration portal for MYK Certified Translations."
        path="/admin"
        noIndex
      />

      <AdminInquiries />
    </>
  );
}

function PaymentSuccessPage() {
  return (
    <>
      <Seo
        title="Payment Successful | MYK"
        description="Confirmation that your payment to MYK Certified Translations was completed successfully."
        path="/payment-success"
        noIndex
      />

      <PaymentSuccess />
    </>
  );
}

function PaymentCancelledPage() {
  return (
    <>
      <Seo
        title="Payment Cancelled | MYK"
        description="Information about a cancelled or incomplete payment to MYK Certified Translations."
        path="/payment-cancelled"
        noIndex
      />

      <PaymentCancelled />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/payment-success" element={<PaymentSuccessPage />} />
      <Route path="/payment-cancelled" element={<PaymentCancelledPage />} />
      <Route path="/contact" element={<ContactRoute />} />
    </Routes>
  );
}